export default {
  locales: ["sv-SE"],
  messages: {
    webinar: {
      fullScreen: "Fullskärm",
      useCoursio: "Använd Coursio-konto för moduler på webinar",
      missedSettings: "Vänligen ställ in dina webinarinställningar eller använd ditt Coursio-konto",
      domain: "Domän",
      description: "Beskrivning",
      roomName: "Rumsnamn",
      enter: "Skriva in",
      isWebinar: "Vänligen välj modultyp:",
    },
    user: {
      updated: "Användarens rättigheter är uppdaterade",
    },
    login: {
      success: "Välkommen",
      loggedOut: "Vi ses snart igen",
      redirectIncoming: "Du är redan inloggad, vi laddar nu ditt konto",
      toDashboard: "Logga in på din sida",
    },
    bug: {
      report: "Support",
      reportTitle: "Skicka förfrågan",
      describe:
        "För kursrelaterade frågor var god kontakta kursskaparen. För platforms relaterade frågor var snäll och beskriv den här.",
      reported: "Din förfrågan har skickats.",
      reportFailed: "Vi kunde inte ta emot din förfrågan.",
    },
    coursio: {
      welcome: "Välkommen till Coursio",
    },
    dashboard: {
      remove: "Är du säker?",
      removed: "Kursen har blivit borttagen",
      filterAll: "Alla",
      filterCompleted: "Genomförda",
      filterNotCompleted: "Inte slutförda",
      filterExpiresSoon: "Går ut snart",
      filterGood: "Bra",
      filterNew: "Nya",
      filterPaid: "Betald",
      filterRegistered: "Registrerad",
      filterRefunded: "Återbetald",
      filterCancelled: "Avbryts",
      filterError: "Error",
      filterOwn: "Egna Kurser",
      filterOthers: "Inbjudna Kurser",
      sortLastVisit: "Senaste besökte",
      sortCreated: "Senaste skapade",
      filterAndSort: "Välj Filtrering och Sortering",
      filter: "Välj Filtrering",
      filterTitle: "Filtrera",
      sortTitle: "Sortera efter",
    },
    ozitor: {
      url: "URL",
      openInNewTab: "Öppna i ny flik",
      createLink: "Skapa länk",
      more: "Mer",
      less: "Mindre",
    },
    students: {
      students: "Deltagare",
      invitations: "Inbjudningar",
    },
    course: {
      nameTooLong: "Kursnamnet får inte överstiga 50 tecken.",
      buy: "Köp kurs",
      Courses: "Kurser",
      category: "Kategori",
      remove: 'Ta bort kurs "{course}?',
      removed: "Kursen har tagits bort",
      revokeAccess: "Ta bort tillgänglighet",
      show: "Visa kurs",
      noSelected: "Inga kurser valda",
      choose: "Välj kurser",
      setAccess: "Välj tillgänglighetstid",
      lastViewedPage: "Sista besökta sida",
      whatIs: "Vad är en online kurs?",
      studentsInvited: "Deltagare har blivit inbjudna till kursen.",
      groupsInvited: "Grupper har blivit inbjudna till kurs",
      goto: "Gå till kurs",
      new: "Kursnamn",
      add: "Lägg till kurs",
      tableOfContents: "Innehållsförteckning",
      access: "Åtkomst to.m: ",
      dateSaved: "Tillgång datum har sparats",
      forever: "Oändlig",
    },
    group: {
      Groups: "Grupper",
      remove: "Ta bort grupp?",
      add: "Lägg till grupp",
      removed: "Gruppen har tagits bort",
      create: "Ny grupp",
      name: "Gruppnamn",
      expunge: "Ta även bort alla rättigheter om är kopplade till denna grupp.",
      doesNotExist: "Gruppen existerar inte",
      noSelected: "Ingen grupp vald",
      revokeAccess: 'Ta bort tillgång för grupp "{group}" till "{course}"?',
      revokedAccess: "Tillgången har tagits bort för gruppen.",
      show: "Visa grupp",
      choose: "Välj grupp",
      removeCourse: "Ta bort kurs",
      removeCourseConfirm:
        "Är du säker på att du vill ta bort kursen från gruppen?",
      removeStudent: "Ta bort deltagare",
      removeStudentConfirm:
        "Är du säker på att du vill ta bort deltagaren från gruppen?",
      removeInvite: "Ta bort inbjudan",
      removeInviteConfirm:
        "Är du säker på att du vill ta bort inbjudan från gruppen?",
      removedInvite: "Inbjudan har tagits bort",
      coursesAdded: "Kurs(er) tillagda",
      courseRemoved: "Kurs borttagen",
      editing: "Redigering Gruppnamn",
      send: "Skicka till mig",
    },
    student: {
      active: "Aktiv {ago}.",
      neverActive: "Deltagaren har aldrig varit inloggad",
      Students: "Deltagare",
      delete: "Ta bort deltagare",
      Invited: "Inbjuden",
      Registered: "Registrerad",
      remove: 'Ta bort deltagare "{student}"?',
      removed: "Deltagaren har blivit borttagen",
      removeFromCourse: "Ta bort från kurs",
      revokeAccess:
        'Ta bort tillgång för deltagare "{student}" från kurs "{course}"?',
      revokedAccess: "Tillgång har blivit borttagen",
      show: "Visa deltagare",
      removeFromGroupShort: "Ta bort från grupp?",
      removeFromGroup: 'Ta bort deltagare "{student} från grupp "{group}" ?',
      removedFromGroup: "Deltagaren har blivit borttagen från gruppen",
      addedToGroup: "Deltagaren har blivit tillagd i gruppen.",
      multiAddedToGroup: "Deltagare har blivit tillagda i gruppen.",
      choose: "Välj deltagare",
      addToCourseShort: "Lägg till kurs",
      add: "Lägg till deltagare",
      inviteNew: "Bjud in deltagare",
      exportDone: "Exporten är skickad till din mail.",
      exportStatisticDone: "Statistisk export skickades till din mail.",
      expel: "Radera deltagarekonto",
      expelConfirm:
        'Uppmärksamhet! Är du säker på att du vill ta bort deltagaren "{student}"? Efter denna åtgärd "{student}" kommer att tas bort för alltid från alla kurser och grupper ',
      expelDone: "Deltagaren har tagits bort från alla dina kurser och grupper",
      noSelected: "Ingen deltagare vald",
    },
    menu: {
      StudentManagement: "Användarhantering",
      Tasks: "Uppgifter",
      Quiz: "Quiz",
      Notes: "Noteringar",
      Stripe: "Stripe",
      Dashboard: "Startsida",
      Notification: "Notifieringar",
      Settings: "Inställningar",
      Incarnate: "Incarnate",
      Invite: "Bjud in",
      Wakeup: "Wake up",
      Logout: "Logga ut",
      Courses: "Kurser",
      ECommerce: "E-handel",
      Store: "Butik",
      saleStats: "Statistik",
      Transactions: "Transaktioner",
      Discounts: "Rabattkod",
      Bundles: "Paket",
      mediaLibrary: "Media bibliotek",
      Back: "Tillbaka",
      Help: "Hjälp",
      SubAccounts: "Underkonton",
      TaC: "Villkor",
    },
    invite: {
      studentInvitedToCourse: "Deltagaren har blivit inbjuden till kursen.",
      groupInvitedToCourse: "Gruppen har blivit inbjuden till kursen.",
      chooseCourses: "Välj grupp(er)",
      chooseGroups: "Välj grupp(er)",
      chooseStudents: "Välj deltagare",
      selectedCourses: "Valda kurser",
      selectedGroups: "Valda grupper",
      selectedStudents: "Deltagare",
      existingStudents: "Befintliga deltagare",
      newStudents: "Nya deltagare",
      groups: "Grupper",
      summary: "Sammanfattning",
      summaryExplanation: "Nedan finns en sammanfattning av dina val.",
      accessTime: "Tillgänglighetstid",
      willHaveAccessTill: "Deltagarna kommer ha tillgång till kurserna t.o.m",
      willHaveAccessFor: "Deltagarna kommer ha tillgång till kurserna i",
      chooseCourseExplanation:
        "Vänligen välj en eller flera kurser att bjuda in deltagaren till",
      chooseAccessTime: "Välj tillgänglighetstid",
      chooseAccessTimeExplanation:
        "Vänligen välj hur lång tid deltagaren ska ha tillgång till kursen/erna efter att ha loggat in första gången",
      chooseEndDate: "Välj ett slutdatum",
      chooseEndDateExplanation:
        "Vänligen välj t.o.m vilket datum gruppen ska ha tillgång till kursen/erna",
      chooseStudentsOrGroups: "Vill du bjuda in deltagare eller grupper?",
      Unlimited: "Oändlig tillgång",
      oneMonth: "En månad",
      threeMonths: "Tre månader",
      sixMonths: "Sex månader",
      oneYear: "Ett år",
      oneAndHalfYear: "Arton Månader",
      twoYears: "Två år",
      accessMonths: "{months} month(s)",
      enterEmail: "Skriv in mailadresser",
      confirmSend: "Bekräfta och skicka",
      sendInvite: "Skicka inbjudan",
      sentOut: "Inbjudningarna har blivit skickade.",
      Invites: "Inbjudningar",
      foundEmails: "Mailadresser",
      createTags: "Tags",
      addToGroup: "Lägg till i grupp",
      createGroupExplanation: "Skriv in ett namn för den nya gruppen",
      success: "Grattis, du har nu bjudit in dina deltagare! Vill du:",
      inviteMore: "Bjuda in fler?",
    },
    invitation: {
      expired:
        "Tidsramen för inbjudningslänken har utgått och kan inte användas längre.",
      used:
        "Inbjudningslänken har redan blivit använd och kan inte användas på nytt.",
      remove: "Ta bort",
      revokeAccess: "Ta bort tillgång?",
      resend: "Återsänd inbjudan",
      resendAll: "Återsänd inbjudningar till alla",
      prolongAccess: "Återsänd inbjudan för kursen?",
      resent: "En inbjudan har skickats på nytt.",
      resentAll: "En inbjudan har skickats på nytt till alla.",
      accept: "Acceptera inbjudan",
      accepted: "Inbjudan accepterad",
      redirectIncoming: "Du kommer att omdirigeras till startsidan.",
      acceptText:
        "Vänligen slutför din inbjudan genom att klicka på knappen nedan. Inbjudan blev skickad till {email}",
      chosen: "Skicka inbjudan till vald e-post",
      notChosen: "Ingen e-post valdes för att skicka en inbjudan till",
      admin: "Adminrättigheter",
    },
    bundle: {
      updated: "Paket uppdaterat.",
      new: "Nytt paket",
      remove: "Ta bort paket",
      removed: "Paket borttaget.",
      removeCourse: "Ta bort kurs",
      removedCourse: "Kurs borttagen från paketet.",
      removeCourseConfirm: "Är du säker på att du vill ta bort kursen?",
      removeBundle: "Är du säker på att du vill ta bort paketet {bundle}?",
      name: "Namn på paketet",
      in1: "{courseCount} kurser i ett paket",
      choose: "Välj paket",
    },
    item: {
      read: "Markera som läst",
    },
    discount: {
      new: "Ny rabattkod",
      remove: "Ta bort rabattkod",
      removed: "Rabattkod borttagen",
      removeDiscount:
        "Är du säker på att du vill ta bort rabattkod «{discount}»?",
      activate: "Aktivera kod",
      code: "Rabattkod",
      enterCode: "Ange kod (max 30 tecken)",
      codeRestriction: "Koden kan inte vara längre än 30 tecken",
      amount: "Belopp",
      active: "Aktiv",
      limitedUse: "Begränsad användning",
      Start: "Start",
      End: "Slut",
      Activation: "Aktivering",
      Manual: "Manuell",
      Date: "Datum",
      All: "Alla",
      Selected: "Valda",
      amountMustBeNumeric: "Beloppet måste vara numeriskt.",
      codeRequired: "Kod krävs",
      used: "{count} / {maxCount} använda",
      applied: "Rabattkod applicerad.",
      typeAbsolute: "Belopp",
      typePercentage: "Procent",
      affectedObjects: "Specifik kurs",
      affectedPackages: "Specifika paket ",
      discount: "Rabatt",
      type: "Rabatt typ",
    },
    transaction: {
      completed: "Avslutad",
      resendReceipt: "Skicka om kvitto",
      refund: "Återbetalning",
      refunded: "Återbetald",
      receiptResent: "Kvittot har skickats igen.",
      refundDone: "Återbetalning genomförd",
      exportDone:
        "Statistik på inkommande transaktioner är skickad till din e-mail.",
      date: "Datum",
      showDetails: "Visa detaljer",
      name: "Namn",
      coursePackage: "Kurs/Paket",
      amount: "Belopp",
      new: "Nya",
      registered: "Registrerad",
      paid: "Betald",
      good: "Bra",
      error: "Fel",
      cancelled: "Avbryts",
    },
    export: {
      startDate: "Startdatum",
      endDate: "Slutdatum",
      course: "Exportera kursdeltagare",
      statistic: "Exportera detaljerad uppgiftsstatistik",
      user: {
        withInactive: "Inkludera inaktivera användare",
        withProgress: "Inkludera kurs statistik",
      },
      userStats: "export användarstatistik",
    },
    image: {
      upload: "Ladda upp bild",
      importFailed: "Importen gick inte igenom, vänligen försök igen.",
      imported: "Bilden har blivit importerad.",
      provideImportUrl: "Opps, du glömde att lägga till en url",
      confirmDelete: "Är du säker på att du vill ta bort bilden?",
      delete: "Ta bort bild",
    },
    audio: {
      upload: "Ladda upp ljudklipp",
      importFailed: "Importen gick inte igenom, vänligen försök igen.",
      imported: "Ljudklippet har blivit importerad",
      confirmDelete: "Är du säker på att du vill ta bort ljudklippet",
      embed: "Klistra in Spofify eller SoundCloud länk",
      download: 'Ladda ner ljud som: ',
    },
    text: {
      confirmDelete: "Är du säker på att du vill ta bort textmodulen?",
    },
    module: {
      confirmDelete: "Är du säker på att du vill ta bort modulen?",
      removeImage: "Ta bort bild",
      dropOneFile: "Släpp en fil här",
      dropImage: "Släpp en bild här",
      dropImages: "Släpp en eller flera bilder här",
      youCanImport: "eller klistra in en länk",
      or: "eller",
      dropVideo: "Släpp en video här",
      dropAudio: "Släpp en ljudfil här",
      uploadOrBrowse: "Du kan också {upload} eller infoga från {library}",
      upload: "ladda upp",
      uploadFile: "Ladda upp en fil",
      uploadImage: "Ladda upp en bild",
      uploadAudio: "Ladda upp en ljudfil",
      uploadVideo: "Ladda upp en video",
      library: "bibliotek",
    },
    Roles: "Roller",
    role: {
      accountant: "Revisor",
      reader: "Deltagare",
      editor: "Redaktör",
      teacher: "Lärare",
      owner: "Ägare",
      darkAdmin: "Sith",
      assistant: "Assistant",
      tester: "Testare",
    },

    video: {
      upload: "Ladda upp video",
      importFailed: "Importen gick inte igenom, vänligen försök igen.",
      imported: "Video har blivit importerad",
      confirmDelete: "Är du säker på att du vill ta bort videon?",
      embed: "Klistra in Youtube, Vimeo eller Wistia länk",
      changesSaved: "Ändringar har sparts",
      changesCannotBeSaved: "Link är inte korrekt",
      allowDownloading: "Tillåt nedladdning",
      download: "Ladda ner",
    },
    download: {
      upload: "Ladda upp fil",
      confirmDelete: "Är du säker på att du vill ta bort filen?",
    },
    discussion: {
      confirmDelete: "Är du säker på att du vill ta bort diskussionen?",
    },
    slideshow: {
      confirmDelete: "Är du säker på att du vill ta bort bildspelet?",
    },
    tasks: {
      noInfo: "Det finns inget att visa",
      noTasks: "No tasks requiring your attention found",
      findCourse: "Hitta kurs",
      findGroup: "Hitta grupp",
      findStudent: "Hitta elev",
      showCorrected: "Visa korrigerade uppgifter",
      fileRemoved: "Filer borttagna",
      fileNotRemoved: "Kunde inte ta bort filer",
      fileUploaded: "Fil bifogad, klicka på SKICKA för att skicka in ditt svar.",
      students: "Elever",
      courses: "Kurser",
      corrected: "Visa korrigerade uppgifter",
      openEnded: "Öppen fråga",
      correct: "Rätt",
      incorrect: "Fel",
      defineTask: "Skriv in fråga",
      defineQuestion: "Skriv en fråga",
      emptyChoice: "Nytt svar",
      addChoice: "Lägg till svar",
      description: "Skriv in fråga",
      submit: "Svara",
      attach: "Bifoga fil",
      answer: "Svara",
      answerOpenEnded: "Skicka",
      noAnswer: "Inget svar angivet",
      provideAnswer: "Skriv in ditt svar",
      feedback: "Feedback",
      provideFeedback: "Vänligen ge användaren feedback",
      type: "Uppgiftstyp",
      chooseType: "Välj uppgiftstyp",
      answeredCount: "{answered}/{count} uppgifter",
      question_description: "Beskriv frågan",
      noAnsweredTasks: "Inga uppgifter",
      singleChoice: "Ett val",
      multipleChoice: "Flerval",
      text: "Öppen",
      pleaseChooseOne: "Vänligen välj en",
      remove: "Ta bort uppgift",
      confirmDelete: "Är du säker på att du vill ta bort uppgiften?",
      feedbackSent: "Din feedback har skickats",
      redoanswer: "Rätta igen",
      answerSent: "Ditt svar har skickats till kursskaparen",
      showMore: "Visa alla resultat",
      showLatest: "Visa senaste resultat",
    },
    post: {
      confirmDelete: "Är du säker på att du vill ta bort ditt inlägg?",
      writeAComment: "Skriv en kommentar",
      describeDiscussion: "Diskussions ämne",
    },
    pageModule: {
      quiz: "Lägg till en fråga",
      quizQuestionErrorTitle: "Felaktig fråga",
      quizQuestionErrorMessage:
        "Sidan innehåller en fråga som saknar korrekt alternativ eller inte har några alternativ",
      quizCommentOnQuestion: "Motivera det rätta svaret",
      add: "Lägg till modul",
      text: "Text",
      video: "Video",
      image: "Bild",
      audio: "Ljud",
      task: "Uppgift",
      webinar: "Webinar",
      download: "Nedladdningsbart",
      discussion: "Diskussion",
      slideshow: "Bildspel",
      created: "Modul tillagd",
      layout: "Översikt",
      embed: "Embed",
      quiziframe: "Quiz",
    },
    card: {
      number: "Kortnummer",
    },
    account: {
      Account: "Konto",
      register:
        "För att komma åt en kurs du behöver för att skapa en Coursio konto. Vänligen fyll i dina uppgifter nedan:",
      need:
        "För att köpa kursen så behöver du ett Coursio konto, fyll i dina uppgifter nedan:",
      create: "Create account",
      have: "Har du redan ett Coursio konto?",
    },
    toc: {
      search: "Sök i kursen",
      accept:
        "Genom att registrera ditt konto så accepterar du våra användarvillkor {toc}",
      toc: "Coursios Användarvillkor.",
      close: "Stäng innehållsförteckning",
      open: "Öppna",
    },
    mediaLibrary: {
      filesRemaining: "filer kvarstår",
      addNew: "Lägg till ny",
      Delete: "Ta bort",
      listView: "Listvy",
      thumbView: "Miniatyrbild",
      type: "Typ",
      remove: "Ta bort fil",
      removed: "Fil borttagen.",
      uploadFiles: "Uppladdade filer",
      removeConfirm: 'Är du säker på att du vill ta bort "{file}"?',
      removeFilesConfirm: "Är du säker på att du vill ta bort filerna?",
      uploadComplete: "Uppladdning genomförd.",
      dropHere: "Släpp filer här",
      Uploading: "Laddar upp...",
      Upload: "Uppladdad",
      createDir: "Skapa mapp",
      directoryName: "Namge mappen",
    },
    page: {
      addContent: "Lägg till modul",
      new: "Ny sida",
      remove: "Ta bort sida",
      rename: "Byt namn på sida",
      duplicate: "Duplicera sida",
      confirmDelete: "Är du säker på att du vill ta bort sidan?",
    },
    section: {
      paste: "Klistra in sektion",
      new: "Nytt avsnitt",
      remove: "Ta bort avsnitt",
      confirmDelete: "Är du säker på att du vill ta bort avsnittet?",
    },
    payment: {
      connectToStripe: "Anslut till Stripe",
      payWithStripe: "Betala med stripe",
      chooseMethod: "Välj betalningsalternativ",
      fillInDetails: "Fyll i dina uppgifter",
      Taxamo: "Kortbetalning",
      Klarna: "Klarna",
      next: "Nästa",
      completePurchase: "Slutför köp",
      creditCard: "Kortbetalning",
      klarna: {
        phone: "Telefon",
        zipCode: "Postnummer",
        emailError: "Vänligen fyll i en korrekt mailadress",
        phoneError: "Vänligen fyll i en korrekt telefonnummer",
        zipCodeError: "Vänligen fyll i ett korrekt postnummer",
        personalNumberError: "Vänligen fyll i ett korrekt personnummer",
        personalOrganisationalNumber: "Personnummer/ Organisationsnummer",
        email: "E-mail",
        next: "Nästa",
        personalNumberFormat: "ÅÅÅÅMMDD-XXXX",
        phoneNumberFormat: "0XX XX XXXX",
        emailFormat: "someone@coursio.com",
        zip: "Postnummer",
        invoice: "Faktura",
        account: "Konto",
        address: "Adress",
        street: "Adress",
        firstName: "Förnamn",
        lastName: "Efternamn",
        city: "Stad",
        country: "Land",
      },
      hint: {
        creditCardNumber: "XXXXXXXXXXXXXXXX",
        expYear: "ÅÅÅÅ",
        expMonth: "MM",
        cvc: "XXX",
      },
      validation: {
        invalidYear: "Ogiltigt år. Måste skrivas in likt ÅÅÅÅ (2020)",
        invalidMonth: "Ogiltig månad. Måste skrivas in likt MM (12)",
        invalidCvC: "Felaktig CVC: Måste skrivas in likt XXX (123)",
        invalidCreditCard: "Inkorrekt kortnummer, måste vara 16 siffror långt",
      },
      stripe: {
        number: "Kortnummer",
        year: "Giltigt till år",
        month: "Giltigt till månad",
        cvc: "CVC",
      },
    },
    validation: {
      invalidEmail: "Skriv in en korrekt e-mailadress",
      required: "Du måste fylla i detta fält",
      passwordTooShort: "Ett lösenord måste innehålla minst 6 tecken",
    },
    password: {
      restoreLinkMailed:
        "Ett mail har skickats med instruktioner på hur du byter ditt lösenord.",
      reset: "Ändra lösenord",
      newPassword: "Nytt lösenord",
      changed: "Ditt lösenord har ändrats",
      confirm: "Bekräfta",
      fillIn: "Fyll i båda fälten",
    },
    loadMore: "Ladda mer",
    areYouSure: "Är du säker?",
    Copy: "Kopia",
    Copied: "Kopierad",
    OK: "OK",
    Cancel: "Avbryt",
    Yes: "Ja",
    No: "Nej",
    Reset: "Nollställ",
    Sort: "Sortera",
    Filter: "Filtrera",
    Create: "Skapa",
    Invite: "Bjud in",
    Export: "Exportera",
    Course: "Kurs",
    Courses: "Kurser",
    Group: "Grupp",
    Time: "Tid",
    Groups: "Grupper",
    Email: " E-postadress",
    Student: "Deltagare",
    Report: "Rapportera",
    Students: "Deltagare",
    Status: "Status",
    Search: "Sök",
    Never: "Aldrig",
    Buy: "Köp",
    Support: "Support",
    Expired: "Utgått",
    selectAll: "Markera alla",
    deselectAll: "Avmarkera alla",
    revokeAccess: "Ta bort tillgång?",
    noResults: "Inget hittades",
    resultsFiltered: "Resultat filtrerat",
    selectedCount: "{num, plural, =0{Inga valda} other{# valda}}",
    Next: "Nästa",
    addFrom: "Lägg till från",
    Login: "Logga in",
    Authenticating: "Autentiserande",
    Caption: "Bildtext",
    Other: "Annat",
    importFromUrl: "Importera från URL",
    Upload: "Ladda upp",
    Import: "Importera",
    Embed: "Bädda in",
    Reply: "Svara",
    Follow: "Följ",
    Unfollow: "Sluta följa",
    Send: "Skicka",
    SortMessages: "Sortera meddelanden",
    attachFile: "Bifoga fil",
    nextPage: "Nästa sida",
    Modules: "Moduler",
    Layout: "Översikt",
    Undo: "Ångra",
    Deleted: "Borttagen.",
    Delete: "Ta bort",
    Discount: "Rabatt",
    Private: "Privat",
    Public: "Publik",
    TermsAndConditions: "Användarvillkor",
    copyright: "Copyright {year} av {name}",
    poweredBy: "Powered by {engine}",
    forgotPassword: "Glömt ditt lösenord?",
    loginWithGoogle: "Logga in med Google",
    loginWithFacebook: "Logga in med Facebook",
    welcomeBack: "Välkommen tillbaka, {user}!",
    useOtherLogin: "Använd ett annat inlogg",
    VAT: "Moms",
    fullName: "Namn",
    firstname: "Förnamn",
    lastname: "Efternamn",
    noTasksOrNotifications: "Inga öppna svar eller diskussioner",
    Branding: "Temasättning",
    Notifications: "Notifieringar",
    or: "eller",
    Remove: "Ta bort",
    Save: "Spara",
    Add: "Addera",
    Clear: "Rensa",
    Logout: "Logga ut",
    gift: {
      explanation:
        "När du köper en kurs som en present, får du en presentkod skickad till din e-post.",
      warning:
        "Viktigt att tänka på! Ange din egen e-post, inte mottagarens e-post.",
      purchaseComplete: "Köp genomfört",
      nextStep:
        "En presentkod har skickats till e-postadressen du angav. Ge den koden till mottagaren av presenten!",
      thisCourse: "Ge bort denna kurs",
      email: "Skriv in din Email",
      confirm: "Verifiera din Email",
      emailMustMatch: "Emailadresserna matchar inte.",
      expired: "Presentkoden har utgått och kan därför inte användas längre.",
      used: "Presentkoden har redan använts och kan därför inte användas igen.",
      accepted: "Presenten accepterad",
      help:
        "Om du använt presentkoden och fått tillgång till kursen loggar du in här-> app.coursio.com/login",
      acceptText: "Du har varit snäll!",
      acceptSubText: "Skriv in din presentkod för att komma åt kursen.",
      redirectIncoming: "Du kommer nu att dirigeras till startsidan",
      redirectLoginPage: "Du kommer nu att dirigeras till inloggningssidan.",
      needCoursioAccount:
        "För att ta del av kursen så behöver du ett Coursio konto.",
      doesNotExist: "This gift code does not exist.",
    },

    store: {
      smallCards: "Cards",
      bigCards: "Big Cards",
      giftCourse: "Köp som gåva",
      buyFor: "Köp för {price}",
      join: "Köp",
      goto: " Gå till butiken",
      edit: "Editera",
      takeCourse: "Gå kurs",
      video: "Video URL",
      price: "Pris",
      private: "Privat",
      public: "Publik",
      purchaseSuccess: "Ditt köp gick igenom.",
      chooseVideo:
        "Vänligen klistra in en video URL från YouTube, Vimeo eller Wistia.",
      yourCourseLeader: "Din kursledare",
      joinCourse: "Köp kurs",
      aboutThisCourse: "Om kursen",
      aboutThisPack: "Om paketet",
      courseContent: "Kursinnehåll",
      aboutAuthor: "Om {author}",
      aboutAuthorInfo: "Information om kursledaren",
      courseCount: "Kurser ({count})",
      name: "Webshops namn",
      grossPrice: "Pris (ink MOMS)",
      packOf: "Paket av {count}",
      noOwnerInfo: "Ingen information om kursledaren ännu",
      chooseCategory: "Välj kategori",
    },
    settings: {
      SendBulletin: 'Skickar bulletiner',
      Bulletin: 'Bulletin',
      Webinar: 'Webinar',
      Docs: "Dokument",
      termsAndConditions: "Användarvillkor",
      courseExplanation: "Vad är en kurs?",
      support: "Support",
      aboutMe: "Om mig",
      storeHeadline: "Webshops header",
      storeBackground: "Webshopens bakgrund",
      readerMode: "Deltagarläge",
      disableScaling: "Inaktivera skalning",
      enableScaling: "Aktivera skalning",
      builderMode: "Skaparläge",
      displayName: "Visningsnamn",
      firstName: "Förnamn",
      lastName: "Efternamn",
      language: "Språk",
      email: "E-mail",
      logo: "Logotyp",
      color: "Färg",
      currency: "Valuta",
      saved: "Inställningar sparade",
      avatar: "Profilbild",
      Account: "Konto",
      Account2: "Användarinställningar",
      Stripe: "Stripe",
      Builder: "Skapare",
      Branding: "Tema",
      ssn: "Organisationsnummer",
      phone: "Telefon",
      address: "Adress",
      zip: "Postnummer",
      city: "Stad",
      country: "Land",
      Codes: "Koder",
      Notifications: "Notifieringar",
      gaCode: "Google Analytics kod",
      fbCode: "Facebook Pixel kod",
      gaGtm: "Google Tag Manager kod",
      checkoutCode: "Utcheckningskod",
      ECommerce: "E-handel",
      currentPassword: "Nuvarande Lösenord",
    },
    subAccount: {
      attention:
        "Varning! Du kommer nu att loggas in som användaren. Alla ändringar du gör kommer att sparas på detta konto.",
      incarnate: "Logga in",
      incarnated: "(Extern inloggning)",
    },
    note: {
      yourNote: "Dina anteckningar...",
    },
    Register: "Registrera",
    notification: {
      NOTIFICATION_ADDED_TO_CIRCLE: "Tillagd till grupp",
      NOTIFICATION_TASK_FEEDBACK: "Feedback på uppgift",
      NOTIFICATION_DRIP_CONTENT: "Droppinnehåll",
      NOTIFICATION_POST_ADDED: "Inlägg tillagd",
      NOTIFICATION_TASK_ASSESSED: "Uppgift rättad",
      NOTIFICATION_YOU_MENTIONED: "Någon nämnde dig",
      NOTIFICATION_FEEDBACK_REQUIRED: "Feedback efterfrågad",
      NOTIFICATION_UNREVIEWED_TASKS: "Orättade uppgifter",
      NOTIFICATION_THREAD_NEW_POSTS: "Nytt inlägg i diskussion",
      NOTIFICATION_COURSE_NEW_POSTS: "Nytt inlägg i kurs",
      NOTIFICATION_COURSE_SOLD: "Kurs såld",
      NOTIFICATION_COURSE_PACKAGE_SOLD: "Kurspaket sålt",
      NOTIFICATION_ADDED_TO_COURSE: "Tillagd till kurs",
      removed: "Nya anmälningar markerades som lästa",
      readAll: "Markera meddelanden som lästa",
      NOTIFICATION_DATA_EXPORT: "Data export",
      NOTIFICATION_COURSE_INVITE: "Kursinbjudan",
      NOTIFICATION_BROADCAST: "Broadcast",
    },
    emailStatus: {
      error: "Error (Detta betyder oftast att mailet inte skickades) ",
      sent: "Skickat",
      bounced: "Bounced",
      rejected: "Rejected",
      unknown: "Okänd mailadress",
    },
    about: {
      support:
        ' Vänligen kontakta <a href="mailto:support@coursio.com">support@coursio.com</a> för teknisk support.',
    },
    personalSettings: "Privata inställningar",
    tag: {
      name: "Tag namn",
      add: "Lägg till tag",
    },
    aboutCoursio:
      "Coursio är en plattform för online utbildningar. Läs mer om oss här {link}.",
    Request: "Skicka",
    Password: "Lösenord",
    Continue: "Nästa",
    changesSaved: "Dina ändringar har sparats.",
    exclVat: "ex. MOMS",
    Edit: "Redigera",
    by: "av",
    Close: "Stäng",
    Tags: "Tags",
    notFound: "404: Sidan ej hittad.",
    here: 'här',
    error: "Ett fel har inträffat och vårt team har meddelats. För att gå tillbaka klicka",
    down:
      "Coursio är nere för tillfället och vi arbetar på problemet. Tack för ditt tålamod!",

    loremIpsum:
      "Hej Skapare! Detta är bara utfyllningstext. Klistra in din text eller börja skriva.",
  },
};



// WEBPACK FOOTER //
// ./src/js/i18n/sv_SE.js